<template>
  <div v-if="$user.primeiroAcesso">
    <transition mode="out-in">
      <Filiacao />
    </transition>
  </div>
  <div v-else>
    <TheHeader />
    <transition mode="out-in">
      <slot />
    </transition>
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import Filiacao from "@/views/Dashboard/Filiacao.vue";
export default {
  name: "Dashboard",
  data() {
    return {
      novoUsuario: false,
    };
  },
  components: {
    TheHeader,
    Filiacao,
  },
  computed: {
    usuario: {
      get() {
        return this.$store.getters.getUsuario;
      },
      set(value) {
        this.$store.commit("UPDATE_USER", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
